import React, { useState } from "react";
import '../css/Dailystatus.css'
import Compose from "./Compose";
import SentItems from "./SentItems";
import DsrArchieve from "./DsrArchieve";
import TimeSheet from "./TimeSheet";

export const DailyStatus = () => {
  const [currentActiveTab, setCurrentActiveTab] = useState('1');
  const [task, setTask] = useState({})
  const [otherTaskHours,setOtherTaskHours]=useState(0);
  const toggle = tab => {
    if (currentActiveTab !== tab) {
      setCurrentActiveTab(tab);
      if (tab !== '1') {
        setTask({});
        setOtherTaskHours(0);
      }
    }
  }

  const updateTask = (data,otherHours) => {
    toggle('1');
    setTask(data)
    setOtherTaskHours(otherHours);
  }

  const TabButton = ({ id, label }) => (
    <button
      type="button"
      onClick={() => toggle(id)}
      className={`relative px-5 py-3 text-sm font-medium whitespace-nowrap transition-all duration-200 border-b-2 ${
        currentActiveTab === id
          ? "border-blue-600 text-blue-600"
          : "border-transparent text-gray-500 hover:text-gray-700"
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="bg-transparent w-full h-full flex flex-col overflow-y-auto overflow-x-hidden">
      <div className="max-w-[1700px] mx-auto px-2 sm:px-4 py-2 sm:py-2 flex-1 w-full flex flex-col mb-2">
        <div className="sticky top-0 z-10 bg-[#f6f6f6] pb-3 pt-2 -mt-2 -mx-2 sm:-mx-4 px-2 sm:px-4">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="flex overflow-x-auto scrollbar-hide">
              <TabButton id="1" label="Compose" />
            <TabButton id="2" label="Sent items" />
            <TabButton id="3" label="Dsr Archive" />
            <TabButton id="4" label="My Time sheet" />
          </div>
        </div>
      </div>
        
        <div className="flex-1">
          {currentActiveTab === '1' && <Compose task={task} otherTaskHours={otherTaskHours}/>}
          {currentActiveTab === '2' && <SentItems updateTask={updateTask}/>}
          {currentActiveTab === '3' && <DsrArchieve />}
          {currentActiveTab === '4' && <TimeSheet />}
        </div>
      </div>
      
      <div className="mt-4">

      </div>
    </div>
  );
};
